import { useState } from 'react';
import { Dispatch, SetStateAction } from 'react';
import { useAgreeDisclosureStatementMutation } from 'views/utils/graphql/graphql';
import useOnceSubmit from 'views/utils/useOnceSubmit';

export const enum ITExplanationModalStep { //ImportantMattersDisclosureType
  CONFIRMATION,
  ELECTRONIC_DELIVERY_OF_DISCLOSURE_DOCUMENT,
  IT_DISCLOSURE_VIA_WEB_CONFERENCE,
  IT_DISCLOSURE_APPLICATION_DATE_SELECTION,
}

export type ModalStepProps = {
  modalStep: ITExplanationModalStep;
  setModalStep: Dispatch<SetStateAction<ITExplanationModalStep>>;
};

export const useITExplanationModal = (props?: ITExplanationModalStep) => {
  const [modalStep, setModalStep] = useState<ITExplanationModalStep>(props ?? ITExplanationModalStep.CONFIRMATION);

  const [, agreeDisclosureStatement] = useAgreeDisclosureStatementMutation();

  const executeToAgreeDisclosureStatement = useOnceSubmit<number>(
    {
      onSubmit: async (param) => {
        // エラーが戻ってきても次に進む
        await agreeDisclosureStatement({
          input: {
            Type: param,
          },
        });
      },
    },
    [agreeDisclosureStatement],
  );

  const setExtraModalStep = async (agreeType: number, step: ITExplanationModalStep) => {
    await executeToAgreeDisclosureStatement(agreeType);
    setModalStep(step);
  };

  return {
    modalStep,
    setModalStep,
    setExtraModalStep,
  };
};
